import { STOModel } from "../../models/base/sto-model";
import { RecaptchaResponseDTO } from "../../models/recaptcha/recaptcha-response-dto";
import { BaseApiService } from "../base";

export class VerifyRecaptchaApiService extends BaseApiService<RecaptchaResponseDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/Recaptcha",
      loadItemsPath: "/VerifyCaptcha",
    });
  }
}
